module.exports = __webpack_public_path__ + "img/symbol_1.130f3bc3.png";